import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function WarningSolidMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path fillRule="evenodd" clipRule="evenodd" d="M12 1.64l10.32 18.72H1.68L12 1.64zm-.984 9.624l.216 2.352h1.512l.24-2.352V9.368h-1.968v1.896zm-.168 5.976h2.256v-2.256h-2.256v2.256z"  /></Svg>;
}
export default WarningSolidMedium;